import { post } from '@alltrails/core/utils/post';
import type { UpsellsRequest } from '@alltrails/types/UpsellsRequest';
import type { UpsellsResponse } from '@alltrails/types/UpsellsResponse';

export const fetchUpsells = (experiments: UpsellsRequest['experiments']) =>
  post<UpsellsResponse>('/api/alltrails/upsells', { experiments } satisfies UpsellsRequest);
